<template>
  <iTextInput
    v-model="value"
    type="number"
    :width="getOptionValue(LayoutWidth)"
    :style-overrides="{
      borderRadius: getOptionValue(BorderRadius)
    }"
  />
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import BorderRadius from "%/dynamic-components/render-engine/options/border-options/border-radius";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";

export default {
  name: "DynamicAppNumberInputElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  hidden: true,
  options: [
    LayoutWidth,
    new LayoutHeight(undefined, true),
  ],
  optionBundles: [
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
  computed: {
    BorderRadius() {
      return BorderRadius;
    },
    LayoutWidth() {
      return LayoutWidth;
    },
    value: {
      get() {
        return this.valueFromContext;
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = value;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
